import { gql } from "@apollo/client";
import { CARD_PROGRAM_FIELDS } from "./cardProgram";

export const GET_CARD_PROGRAM_OPTIONS = gql`
  query getCardProgramOptions {
    getCardProgramOptions {
      platformIntegrationId
      cardIssuer
      productKey
      productName
      subAccountType
      connectionId
      requiresOnboarding
      connected
      cardIssuerAccountKeyField {
        labelKey
        helpKey
      }
    }
  }
`;

export const START_CARD_PROGRAM = gql`
  ${CARD_PROGRAM_FIELDS}
  mutation startCardProgram($input: StartCardProgramInput!) {
    startCardProgram(input: $input) {
      hostedUrl
      connection {
        id
        issuer
        status
      }
      program {
        ...CardProgramFields
      }
    }
  }
`;

export const REMOVE_CARD_PROGRAM = gql`
  mutation removeCardProgram($id: ID!) {
    removeCardProgram(id: $id) {
      id
      status
    }
  }
`;
